'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ContentRoutes from 'ContentUtils/Routes';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIDropdownDivider from 'UIComponents/dropdown/UIDropdownDivider';
import UIList from 'UIComponents/list/UIList';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { getCategoryId } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getContentModelId, getContentModelName } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getMABExperimentVariantsWithMaster } from 'ContentEditorUI/redux/selectors/mabExperimentSelectors';
import { getHasUnsavedChanges } from 'ContentEditorUI/redux/selectors/saveDataSelectors';
import { getHasMABAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
import { useTestVariationDropdownButtonProps } from 'ContentEditorUI/hooks/useTestVariationDropdownButtonProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MABControls = ({
  autoSave,
  onManageTestClick,
  TestVariationTourSecondStep,
  endTour,
  goToStepTwo
}) => {
  const categoryId = useSelector(getCategoryId);
  const currentId = useSelector(getContentModelId);
  const currentName = useSelector(getContentModelName);
  const variants = useSelector(getMABExperimentVariantsWithMaster);
  const hasUnsavedChanges = useSelector(getHasUnsavedChanges);
  const hasMABAccess = useSelector(getHasMABAccess);
  const dropdownButtonProps = useTestVariationDropdownButtonProps({
    pageName: currentName
  });
  const handleVariantClick = variantId => {
    if (hasUnsavedChanges) {
      autoSave().then(() => {
        window.location = ContentRoutes.edit(variantId, categoryId);
      }).catch(error => {
        console.error(error);
      });
    } else {
      window.location = ContentRoutes.edit(variantId, categoryId);
    }
  };
  const dropdown = /*#__PURE__*/_jsx(UIDropdown, Object.assign({}, dropdownButtonProps, {
    onOpenComplete: goToStepTwo,
    onOpenChange: ({
      target: {
        value: open
      }
    }) => {
      if (!open) {
        endTour();
      }
    },
    children: /*#__PURE__*/_jsx(TestVariationTourSecondStep, {
      children: /*#__PURE__*/_jsxs(UIList, {
        children: [variants.map(variant => {
          const variantId = variant.get('id');
          const name = currentId === variantId ? currentName : variant.get('name');
          return /*#__PURE__*/_jsx(UIButton, {
            active: currentId === variantId,
            onClick: (...partialArgs) => handleVariantClick(variantId, ...partialArgs),
            children: name
          }, variantId);
        }), hasMABAccess && /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(UIDropdownDivider, {}), /*#__PURE__*/_jsx(UIButton, {
            use: "transparent",
            className: "p-x-5",
            onClick: onManageTestClick,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pageSettings.mabControls.manageTest"
            })
          })]
        }, "manageTest")]
      })
    })
  }));
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "abDropdownControls.tooltip"
    }),
    placement: "bottom",
    children: dropdown
  });
};
MABControls.propTypes = {
  autoSave: PropTypes.func.isRequired,
  onManageTestClick: PropTypes.func,
  renderPopover: PropTypes.func,
  endTour: PropTypes.func.isRequired,
  goToStepTwo: PropTypes.func.isRequired,
  TestVariationTourSecondStep: PropTypes.node.isRequired
};
export default MABControls;